export const PHONE = '+38 (099) 999-99-99'
export const DATE = '99.99.9999'
export const TIME = '99:99'
